import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'prlw-edit-trader-tariff-ui',
  templateUrl: './edit-trader-tariff.component.html',
  styleUrl: './edit-trader-tariff.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditTraderTariffComponent {
  @Input() shipmentBasisName: string | null = null;
  @Input() source: string | null = null;
  @Input() price: number | null = null;
  @Input() changeSimilarProductsTariff: boolean | null = true;
  @Input() deliveryMethod: string | null = null;

  @Output() eventClose = new EventEmitter<void>();
  @Output() eventPrice = new EventEmitter<FormControl>();
  @Output() eventDelete = new EventEmitter<void>();
  @Output() eventChangeChangeSimilarProductsTariff =
    new EventEmitter<boolean>();

  get isTraderTariff() {
    return this.source === 'Тарифная сетка';
  }
}
